<router-outlet></router-outlet>
<div *ngIf="isLoading" class="loading-layout">
    <mat-spinner [diameter]="40"></mat-spinner>
</div>
